const getters = {
    getJobList(state) {
        return state.jobList;
    },
    getJob(state) {
        return state.job;
    }
}

export default getters;